<template>
    <div>
        <div class="row">
            <div class="col-sm-12">
                <div class="page-title-box">
                    <div class="float-right">
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="javascript:void(0);">BPD BALI</a></li>
                            <li class="breadcrumb-item active">Transaksi</li>
                            <li class="breadcrumb-item active">
                                {{ $route.name == 'instanceTransactionCreate' ? 'Create' : 'Edit' }}</li>
                        </ol>
                    </div>

                    <h4 class="page-title">
                        <router-link :to="{ name: 'instanceTransaction' }">
                            <i class="fas fa-arrow-left mr-2"></i>
                        </router-link>
                        Transaksi
                    </h4>
                </div>
            </div>
        </div>

        <!-- <form @submit.prevent="submitForm()"> -->
            <!-- <ul class="nav nav-pills mb-3" id="pills-tab" role="tablist">
                <li class="nav-item">
                    <a class="nav-link active" id="pills-index-tab" data-toggle="pill" href="#pills-index" role="tab" aria-controls="pills-index" aria-selected="true">Transaksi</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" id="pills-forfeit-tab" data-toggle="pill" href="#pills-forfeit" role="tab" aria-controls="pills-forfeit" aria-selected="false">Denda</a>
                </li>
            </ul> -->


            <div class="card">
                <div class="card-body">
                    <div class="row">
                        <div class="col-12 col-md-6">
                            <label for="example-text-input" class="col-form-label text-left d-block">Wajib Retribusi</label>
                            <div class="d-flex">
                                <div class="form-group mb-0 " style="width: 90%"
                                    :class="{ 'is-invalid': $v.transactionForm.retribution_id.$error }">
                                    <!-- <select class="form-control select-2-form" id="select-2-customer" :disabled="loading"
                                        v-model.trim="$v.transactionForm.retribution_id.$model" v-select2>
                                        <option value="" selected disabled>--- Pilih Wajib Retribusi ----</option>
                                        <option :value="item.id" :data-name="item.name" v-for="item in dataCustomer"
                                            :key="item.id">
                                            <b>{{item.customer_code ? '(' +item.customer_code +')' : ''}}</b> {{item.name}}</option>
                                    </select> -->
                                    <!-- {{dataCustomer}}
                                    {{transactionForm.retribution_id}} -->

                                    <v-select :filterable="false" :options="dataCustomer" @search="onSearch" ref="city_search" placeholder="Cari nama wajib retribusi ..." 
                                        v-model="$v.transactionForm.retribution_id.$model"
                                        class="ml-10 v-select-filter-home"
                                        :reduce="data => data.id"
                                        label="label"
                                        >
                                        <template slot="no-options">
                                            Cari nama wajib retribusi
                                        </template>

                                        <template #selected-option="{ customer_code, name }">
                                            <b>{{customer_code ? '(' +customer_code +')' : ''}}</b> {{name}}
                                        </template>
                                        <template slot="option" slot-scope="option">
                                            <b>{{option.customer_code ? '(' +option.customer_code +')' : ''}}</b> {{option.name}}
                                        </template>
                                    </v-select>

                                    <div class="error" v-if="!$v.transactionForm.retribution_id.required">Wajib retribusi
                                        wajib diisi</div>
                                </div>
                                <button class="btn btn-warning ml-1" @click="downloadPDF()" :disabled="!transactionForm.retribution_id">
                                    <i class="fas fa-print"></i>
                                </button>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <!-- {{transactionForm.date}} -->
                            <div class="form-group mb-0" :class="{ 'is-invalid': $v.transactionForm.date.$error }">
                                <label for="example-text-input" class="col-form-label text-left d-block">Tanggal</label>
                                <!-- <input type="text" v-model.trim="$v.transactionForm.date.$model" class="form-control"
                                    readonly> -->
                                    <!-- {{transactionForm.date}} -->
                                    <DatePicker  required style="width: 100%" :disabled-date="notAfterToday"
                                            v-model="$v.transactionForm.date.$model" valueType="format" format="DD/MM/YYYY"></DatePicker>
                                <!-- <date-picker style="width: 100%" :disabled-date="notAfterToday" v-model="transactionForm.date" type="date" format="DD/MM/YYYY" ></date-picker> -->
                                <div class="error" v-if="!$v.transactionForm.date.required">Tanggal wajib diisi</div>
                            </div>
                        </div>
                    </div>

                    <div class="row" v-if="transactionForm.retribution_id == 'WALKING_CUSTOMER'">
                        <div class="col-12 col-md-6">
                            <div class="form-group mb-0" :class="{ 'is-invalid': $v.transactionForm.retribution_name.$error }">
                                <label for="example-text-input" class="col-form-label text-left d-block">Nama Retribusi</label>
                                <input type="text" v-model.trim="$v.transactionForm.$model.retribution_name" class="form-control">
                                <div class="error" v-if="!$v.transactionForm.retribution_name.required">Nama Retribusi wajib diisi</div>
                            </div>
                        </div>
                        <div class="col-12 col-md-6">
                            <div class="form-group mb-0">
                                <label for="example-text-input" class="col-form-label text-left d-block">Alamat Wajib Retribusi</label>
                                <input type="text" v-model.trim="transactionForm.retribution_address" class="form-control">
                            </div>
                        </div>
                    </div>

                    <div v-if="companyType != 'HEALTH_CARE'">
                        <div class="form-group mb-0 mt-3">
                            <div class="custom-control custom-switch switch-primary">
                                <input type="checkbox" class="custom-control-input" id="customSwitchPrimary" v-model="penaltyForm.is_penalty">
                                <label class="custom-control-label" for="customSwitchPrimary">Terdapat denda pada transaksi ini</label>
                            </div>
                        </div>

                        <div v-if="penaltyForm.is_penalty">
                            <div class="row">
                                <div class="col-12 col-lg-6">
                                    <div class="form-group">
                                        <label for="example-text-input" class="col-form-label text-left d-block">Periode</label>
                                        <select class="form-control" v-model="penaltyForm.penalty_period">
                                            <option value="DAILY">Harian</option>
                                            <option value="WEEKLY">Mingguan</option>
                                            <option value="MONTHLY">Bulanan</option>
                                            <option value="YEARLY">Tahunan</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-3">
                                    <div class="form-group" :class="{ 'is-invalid': $v.penaltyForm.penalty_period_value.$error }">
                                        <label for="example-text-input" class="col-form-label text-left d-block">Periode Penalti</label>
                                        <div class="input-group">
                                            <input type="number" class="form-control" v-model.trim="$v.penaltyForm.penalty_period_value.$model">
                                            <div class="input-group-append">
                                                <span class="input-group-text">{{penaltyPeriodConvert}}</span>
                                            </div>
                                        </div>
                                        <div class="error" v-if="!$v.penaltyForm.penalty_period_value.required">Periode penalti wajib diisi</div>
                                        <div class="error" v-if="!$v.penaltyForm.penalty_period_value.minValue">Periode penalti minimal adalah 1</div>
                                    </div>
                                </div>

                                <div class="col-12 col-lg-3">
                                    <div class="form-group" :class="{ 'is-invalid': $v.penaltyForm.due_date.$error }">
                                        <label for="example-text-input" class="col-form-label text-left d-block">Tanggal Penalti</label>
                                        <input type="text" class="form-control" v-model="penaltyForm.due_date" readonly v-if="penaltyForm.penalty_period != 'YEARLY'">
                                        <!-- <input type="text" placeholder="DD/MM/YYYY" class="form-control" v-else> -->
                                        <DatePicker required style="width: 100%" v-else v-model.trim="$v.penaltyForm.due_date.$model" valueType="format" placeholder="DD/MM/YYYY" :format="`DD/MM/YYYY`"></DatePicker>
                                        <div class="error" v-if="!$v.penaltyForm.due_date.required">Tanggal Penalti wajib diisi</div>
                                    </div>
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12 col-md-6">
                                    <div class="form-group">
                                        <label for="example-text-input" class="col-form-label text-left d-block">Persentase</label>
                                        <select class="form-control" v-model="penaltyForm.penalty_nominal_type">
                                            <option value="FIXED">Harga Tetap</option>
                                            <option value="PERCENTAGE">Persentase</option>
                                        </select>
                                    </div>
                                </div>

                                <div class="col-12 col-md-6">
                                    <div class="form-group mb-0" :class="{ 'is-invalid': $v.penaltyForm.penalty_nominal_value.$error }">
                                        <label for="example-text-input" class="col-form-label text-left d-block">Jumlah penalti ({{penaltyForm.penalty_nominal_type == 'FIXED' ? 'Rp.' : '%'}})</label>
                                        <input type="text" v-currency="currencyMask" class="form-control" v-model.trim="$v.penaltyForm.penalty_nominal_value.$model">
                                        <div class="error" v-if="!$v.penaltyForm.penalty_nominal_value.required">Jumlah penalti wajib diisi</div>
                                        <!-- <div class="error" v-if="!$v.penaltyForm.penalty_nominal_value.minValue">Jumlah penalti minimal adalah 1</div> -->
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div class="d-flex">
                <button type="button" class="btn btn-primary waves-effect waves-light"
                    style="margin-bottom: 20px; margin-left:auto" @click="addService()" :disabled="loading">
                    <i class="fas fa-plus mr-2"></i>
                    <span>Tambah</span>
                </button>
            </div>

            <div class="card mb-0">
                <table class="table mb-0">
                    <thead>
                        <th>Aksi</th>
                        <th>Kategori Retribusi</th>
                        <th>Harga</th>
                        <th>Jumlah</th>
                        <th>Total</th>
                    </thead>
                    <tbody v-if="loaderService">
                        <tr>
                            <td colspan="5" class="text-center">
                                <div class="justify-content-center">
                                    <div class="spinner-border" style="width: 3rem; height: 3rem;" role="status">
                                        <span class="sr-only">Loading...</span>
                                    </div>
                                    <p class="mt-2">Loading</p>
                                </div>
                            </td>
                        </tr>
                    </tbody>
                    <tbody v-else>
                        <!-- NOTE: NEED TO WORK WITH THIS VALIDATION -->
                        <tr v-if="transactionForm.objectRetribution.length <= 0">
                            <td colspan="5" class="text-center">Belum ada data wajib retribusi</td>
                        </tr>
                        <template v-else-if="transactionForm.objectRetribution.length >= 0 && !loadingInitial">
                            <!-- {{dataService.find(item => {
                                return item.id == '25fa93ae-f46e-48c1-b34c-bd808bbe4aff'
                            })}} -->
                            <Field
                                v-for="(item, index) in transactionForm.objectRetribution"
                                :key="item.index" :dataService="dataService" :index="index" :loading="false"
                                :dataObjectRetribution="transactionForm.objectRetribution"
                                :validationItter="validationItter"
                                @handleData="setData" @handleRemove="removeService">
                            </Field>
                        </template>

                        <template v-if="companyType == 'HEALTH_CARE'">
                            <tr v-if="transactionForm.objectRetribution.length > 0 && this.userType != 'COMPANY OPERATOR'">
                                <td colspan="3">
                                    <label class="mt-1 d-block text-right">Metode Pembayaran </label>
                                </td>
                                <td colspan="2">
                                    <div class="form-group mb-0"
                                        :class="{ 'is-invalid': $v.transactionForm.payment_method.$error }">
                                        <select class="form-control select-2-form-payment" id="select-2-payment"
                                            :disabled="loading" v-model.trim="$v.transactionForm.payment_method.$model"
                                            v-select2>
                                            <option value="" selected disabled>--- Pilih Metode Pembayaran ----</option>
                                            <option value="BPD" v-if="this.$store.state.userData.company.payment_methods.includes('BPD')">BPD Bali</option>
                                            <option value="QRIS" v-if="this.$store.state.userData.company.payment_methods.includes('QRIS')">QRIS Dinamis</option>
                                            <option value="QRIS_STATIC" v-if="this.$store.state.userData.company.payment_methods.includes('QRIS_STATIC')">QRIS Statis</option>
                                            <option value="TUNAI" v-if="this.$store.state.userData.company.payment_methods.includes('TUNAI')">Tunai</option>
                                        </select>
                                        <div class="error" v-if="!$v.transactionForm.payment_method.required">Metode
                                            pembayaran wajib diisi</div>
                                    </div>
                                </td>
                            </tr>
                        </template>

                        <template v-else>
                            <tr>
                                <td colspan="3">
                                    <label class="mt-1 d-block text-right">Metode Pembayaran </label>
                                </td>
                                <td colspan="2">
                                    <div class="form-group mb-0"
                                        :class="{ 'is-invalid': $v.transactionForm.payment_method.$error }">
                                        <select class="form-control select-2-form-payment" id="select-2-payment"
                                            :disabled="loading" v-model.trim="$v.transactionForm.payment_method.$model"
                                            v-select2>
                                            <option value="" selected disabled>--- Pilih Metode Pembayaran ----</option>
                                            <option value="BPD" v-if="this.$store.state.userData.company.payment_methods.includes('BPD')">BPD Bali</option>
                                            <option value="QRIS" v-if="this.$store.state.userData.company.payment_methods.includes('QRIS')">QRIS Dinamis</option>
                                            <option value="QRIS_STATIC" v-if="this.$store.state.userData.company.payment_methods.includes('QRIS_STATIC')">QRIS Statis</option>
                                            <option value="TUNAI" v-if="this.$store.state.userData.company.payment_methods.includes('TUNAI')">Tunai</option>
                                        </select>
                                        <div class="error" v-if="!$v.transactionForm.payment_method.required">Metode
                                            pembayaran wajib diisi</div>
                                    </div>
                                </td>
                            </tr>
                        </template>

                        <tr v-if="transactionForm.objectRetribution.length > 0">
                            <td colspan="3">
                                <label class="mt-1 d-block text-right">Total </label>
                            </td>
                            <td colspan="2">
                                <div class="form-group mb-0">
                                    <input class="form-control text-right" type="text" v-currency="currencyMask" :value="totalPrice"
                                    readonly :disabled="loading">

                                    <input class="form-control text-right" type="text" :value="totalPrice"
                                    v-show="false"
                                    readonly :disabled="loading">
                                </div>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
            
            <button class="btn btn-success waves-effect waves-light mb-5" style="margin-top: 20px" :disabled="loading"
                v-if="companyType == 'OTHER'"
                @click.prevent="submitForm('SAVE')">
                Simpan Transaksi
                <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                    <span class="sr-only">Loading...</span>
                </div>
            </button>

            <div v-if="companyType == 'HEALTH_CARE'">
                <button class="btn btn-success waves-effect waves-light mb-5 mr-3" style="margin-top: 20px" 
                    @click.prevent="submitForm('SAVE')"
                    :disabled="transactionForm.objectRetribution.length <= 0 || loading"
                    v-if="userType != 'COMPANY OPERATOR'">
                    Simpan Transaksi
                    <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                        <span class="sr-only">Loading...</span>
                    </div>
                </button>
                <button class="btn btn-warning waves-effect waves-light mb-5" style="margin-top: 20px" :disabled="loading"
                    @click.prevent="submitForm('DRAFT')">
                    Simpan Sebagai Draft
                    <div class="spinner-border text-light ml-2" role="status" v-if="loading">
                        <span class="sr-only">Loading...</span>
                    </div>
                </button>
            </div>
        <!-- </form> -->
    </div>
</template>

<script>
import moment from 'moment'
import Swal from "sweetalert2";
import Field from './field'
import DatePicker from 'vue2-datepicker'
import 'vue2-datepicker/index.css'
import { required, integer, minValue, requiredIf } from 'vuelidate/lib/validators'
import fileDownload from 'js-file-download'
import { debounce } from "debounce"

export default {
    data() {
        return {
            loadingInitial: true,
            loadingDownloadPDF: false,
            loading: false,
            loaderService: false,
            validationItter: { error: false, message: '', index: 0},
            // FORM TRANSACTION
            transactionForm: {
                retribution_name: '',
                retribution_address: '',
                retribution_id: '',
                date: null,
                objectRetribution: [
                    {
                        id: '',
                        price: 0,
                        amount: 1,
                        unit: 0,
                        unit_type: '',
                        total: 0,
                    }
                ],
                payment_method: ''
            },
            // PENALTY FORM
            penaltyForm:{
                is_penalty: 0,
                penalty_period: 'DAILY',
                penalty_period_value: 1,
                due_date: moment().add(1, 'd').format('DD/MM/YYYY'),
                penalty_nominal_type: 'FIXED',
                penalty_nominal_value: 0
            },
            // MASTER DATA
            dataCustomer: [],
            dataService: [],
        }
    },
    validations() {
        if(this.companyType == 'OTHER') {
            if (!this.penaltyForm.is_penalty) {
                return {
                    transactionForm: {
                        retribution_name: {required : requiredIf(function (data) {
                            return this.transactionForm.retribution_id == 'WALKING_CUSTOMER'
                        })},
                        retribution_id: { required },
                        date: { required },
                        payment_method: { required }
                    }
                }
            }else{
                return {
                    transactionForm: {
                        retribution_name: {required : requiredIf(function (data) {
                            return this.transactionForm.retribution_id == 'WALKING_CUSTOMER'
                        })},
                        retribution_id: { required },
                        date: { required },
                        payment_method: { required }
                    },
                    penaltyForm: {
                        penalty_period_value: { required, minValue: minValue(1) },
                        penalty_nominal_value: { required },
                        due_date: { required }
                    }
                }
            }
        }else if(this.companyType == 'HEALTH_CARE'){
            return {
                transactionForm: {
                    retribution_id: { required },
                    date: { required },
                    payment_method: { required }
                }
            }
        }
    },
    computed:{
        // COUNT TOTAL PRICE
        totalPrice() {
            return this.transactionForm.objectRetribution.reduce((a, {total}) => a + total, 0);
        },
        // CONVERT PENALTY PERIOD NAME 
        penaltyPeriodConvert() {
            const period = this.penaltyForm.penalty_period
            if(period == 'DAILY'){
                return 'Harian'
            }else if(period == 'WEEKLY'){
                return 'Mingguan'
            }else if(period == 'MONTHLY'){
                return 'Bulanan'
            }else{
                return 'Tahunan'
            }
        },
        // SET PENALTY DUE DATE
        penaltyDueDate(){
            return {
                penalty_period: this.penaltyForm.penalty_period,
                penalty_period_value: this.penaltyForm.penalty_period_value,
            }
        }
    },
    watch: {
        // WATCH EVERY CHANGE ON PENALTY DUE
        penaltyDueDate: {
            handler(val){
                const penalty = this.penaltyForm
                if(penalty.penalty_period == 'DAILY'){
                    penalty.due_date = moment().add(penalty.penalty_period_value, 'd').format('DD/MM/YYYY');
                }else if(penalty.penalty_period == 'WEEKLY'){
                    penalty.due_date = moment().add(penalty.penalty_period_value, 'w').format('DD/MM/YYYY');
                }else if(penalty.penalty_period == 'MONTHLY'){
                    console.log(penalty.penalty_period, penalty.penalty_period_value, moment().add(penalty.penalty_period_value, 'm').format('DD/MM/YYYY'));
                    penalty.due_date = moment().add(penalty.penalty_period_value, 'M').format('DD/MM/YYYY');
                }else{
                    penalty.due_date = moment().add(penalty.penalty_period_value, 'y').format('DD/MM/YYYY');
                }
            },
            deep: true
        }
    },
    components: {
        Field,
        DatePicker
    },
    methods: {
        onSearch(search, loading) {
            if(search.length >= 3) {
                loading(true);
                this.search(loading, search, this);
            }
        },
        search: debounce(async (loading, search, vm) => {
            try {
                const customer = await vm.$http.get(`${vm.API_URL}customer`, {
                    headers: { 
                        'Authorization': `Bearer ${vm.$cookies.get("token_instance")}`,
                    },
                    params: {
                        search: search
                    }
                })

                vm.dataCustomer = []
                vm.dataCustomer = customer.data.data.data
                vm.dataCustomer.unshift({ id: 'WALKING_CUSTOMER', name: 'Walk-in Customer' })

                loading(false)
            } catch (error) {
                loading(false)
                console.log(error);
                vm.errorHandler(error)
            }
        }, 1500),
        downloadPDF() {
            this.loadingDownloadPDF = true
            const data = this.dataCustomer.filter(item => item.id == this.transactionForm.retribution_id)
            console.log(data);
            const filename = `${data[0].name.split(' ').join('-')}-${data[0].customer_code}.pdf`

            this.$http.get(`${this.API_URL}customer/export/${this.transactionForm.retribution_id}`, {
                responseType: 'blob',
                headers: { 
                    'Authorization': `Bearer ${this.$cookies.get("token_instance")}`,
                }
            })
            .then(response => {
                this.loadingDownloadPDF = false
                fileDownload(response.data, filename);
            })
            .catch(error => {
                this.loadingDownloadPDF = false
            })
        },
        // SET DATA TRANSACTION IN CHILDREN TO PARENT (THIS COMPONENT)
        setData(val) {
            const index = val.index
            this.$set(this.transactionForm.objectRetribution, index,  {
                id: val.id,
                price: parseInt(val.price),
                amount: parseInt(val.amount),
                unit: parseInt(val.unit),
                unit_type: val.unit_type,
                total: parseInt(val.total),
            })
        },
        // LOAD INITIAL DATA THAT NEEDED BEFORE CREATE FORM
        async loadInitialData() {
            this.loadingInitial = true

            // const customer = this.$http.get(`${this.API_URL}customer`, {
            //     headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            // })
            const service = this.$http.get(`${this.API_URL}service`, {
                headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
            })

            let transaction
            if(this.$route.name == 'instanceTransactionEdit'){
                transaction = await this.$http.get(`${this.API_URL}transaction/${this.$route.params.id}`, {
                    headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                })
            }

            await Promise.all([service])
            .then(([responseService]) => {
                if(this.companyType == 'OTHER'){
                    this.dataCustomer.unshift({ id: 'WALKING_CUSTOMER', name: 'Walk-in Customer' })
                }else if(this.companyType == 'HEALTH_CARE'){
                    this.transactionForm.payment_method = 'BPD'
                }
                this.dataService = responseService.data.data
                setTimeout(() => {
                    $('.select-2-form').select2();
                    $('.select-2-form-payment').select2();
                    $('.select-2-custom-form').select2();
                }, 1000);
            })

            this.loadingInitial = false

            if(this.$route.name == 'instanceTransactionEdit'){
                const data = transaction.data.data
                
                this.transactionForm = {
                    retribution_name: 'asd',
                    retribution_address: '',
                    retribution_id: data.customer_id,
                    date: moment(data.invoice_date).format('DD/MM/YYYY'),
                    objectRetribution: data.objectRetribution.map(item => {
                        return {
                            id: item.service_id,
                            price: item.price,
                            amount: item.qty,
                            unit: item.unit,
                            unit_type: item.unit_type,
                            total: item.total,
                        }
                    }),
                    payment_method: data.payment_method
                }
            }
        },
        // ADD NEW SERVICE
        addService() {
            this.validationItter = { error: false, message: '', index: 0}
            this.transactionForm.objectRetribution
            .push({
                id: '',
                price: 0,
                amount: 1,
                unit: 1,
                unit_type: null,
                total: 0
            })
            setTimeout(() => {
                $('.select-2-custom-form').select2();
            }, 50);
        },
        // REMOVE SERVICE BASED ON INDEX
        removeService(index) {
            Swal.fire({
            title: 'Apakah anda yakin untuk menghapus?',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya, Hapus!'
            }).then((result) => {
                if (result.value) {
                    this.$delete(this.transactionForm.objectRetribution, index)
                    this.loaderService = true
                    setTimeout(() => {
                        this.loaderService = false
                    }, 100);
                }
            })
        },
        // SUBMIT FORM 
        async submitForm(type) {
            // CHECK VALIDATION
            if (this.$v.$invalid) {
                if(this.$v.transactionForm.$invalid){
                    $('.nav-item a[href="#pills-index"]').tab('show');
                }else{
                    $('.nav-item a[href="#pills-forfeit"]').tab('show');
                }
                this.$v.$touch()
                this.sAlert('error', 'Harap isi semua form dengan benar!')
                return
            }
            
            // CHECK VALIDATION ON SERVICES
            this.validationItter = { error: false, message: '', index: 0}
            for (const [index, element] of this.transactionForm.objectRetribution.entries()) {
                if(element.id == ''){ 
                    this.validationItter.error = true
                    this.validationItter.message = 'Kategori Retribusi wajib dipilih'
                    this.validationItter.index = index
                    break
                }else if(element.amount <= 0 || element.amount == ''){
                    this.validationItter.error = true
                    this.validationItter.message = 'Jumlah wajib diisi atau tidak boleh kurang dari 0'
                    this.validationItter.index = index
                    break
                }
            }

            let api = null
            let method = null

            if(this.$route.name == 'instanceTransactionEdit'){
                api = `${this.API_URL}transaction/update/${this.$route.params.id}`
                method = 'PUT'
            }else{
                api = `${this.API_URL}transaction/store`
                method = 'POST'
            }

            // CHECK VALIDATION
            if(this.validationItter.error){
                $('.nav-item a[href="#pills-index"]').tab('show');
                this.sAlert('error', this.validationItter.message)
                return
            }else{
                this.validationItter.error = false
            }

            this.loading = true
            
            // SET STORED DATA
            let storedData
            const defaultData = {
                is_walking_customer: this.transactionForm.retribution_id == 'WALKING_CUSTOMER' ? 1 : 0,
                retribution_name: this.transactionForm.retribution_name,
                retribution_address: this.transactionForm.retribution_address,
                retribution_id: this.transactionForm.retribution_id,
                date: this.transactionForm.date ? this.transactionForm.date : null,

                objectRetribution: this.transactionForm.objectRetribution.map(item => {
                    return {
                        id: item.id,
                        price: item.price,
                        amount: this.reInteger(item.amount),
                        unit: this.reInteger(item.unit),
                        unit_type: this.reInteger(item.unit_type),
                        total: this.reInteger(item.total),
                    }
                }),

                is_draft: type == 'DRAFT' ? 1 : 0,

                payment_method: this.transactionForm.payment_method,
                total: this.reInteger(this.totalPrice)
            }

            if(this.penaltyForm.is_penalty == false){
                storedData = {
                    ...defaultData,
                    // PENALTY
                    is_penalty: this.penaltyForm.is_penalty,
                    penalty_period: null,
                    penalty_period_value: null,
                    due_date: null,
                    penalty_nominal_type: null,
                    penalty_nominal_value: null,
                }
            }else{
                storedData = {
                    ...defaultData,
                    // PENALTY
                    is_penalty: this.penaltyForm.is_penalty,
                    penalty_period: this.penaltyForm.penalty_period,
                    penalty_period_value: this.penaltyForm.penalty_period_value,
                    due_date: this.penaltyForm.due_date ? this.penaltyForm.penalty_period == 'YEARLY' ? this.penaltyForm.due_date : this.convertDate(this.penaltyForm.due_date) : null,
                    penalty_nominal_type: this.penaltyForm.penalty_nominal_type,
                    penalty_nominal_value: this.reInteger(this.penaltyForm.penalty_nominal_value)
                }
            }

            if(this.transactionForm.payment_method == 'QRIS_STATIC'){
                var valueCode = null 
                if(type == 'SAVE'){
                    Swal.fire({
                        input: 'text',
                        inputPlaceholder: 'Masukkan Ref ID / Arsip',
                        showCancelButton: true,
                        confirmButtonText: 'Simpan Transaksi!',
                        html: `Masukkan Ref ID / Arsip`,
                        inputValidator: (value) => {
                            valueCode = value
                        }
                    })
                    .then(async (result) => {
                        if (result.isConfirmed) {
                            this.sAlert('info', 'Sedang Mendownload ...')

                            storedData = {
                                ...storedData,
                                ref_qris_static: valueCode
                            }

                            await this.storeTransaction(method, api, storedData)

                            // Swal.close()
                        } else{
                            this.loading = false
                            Swal.close()
                        }
                    })
                    .catch(error => {
                        console.log(error);
                        this.sAlert('error', "Error, Terjadi Kesalahan!")
                    });
                }else{
                    await this.storeTransaction(method, api, storedData)
                }
            }else{
                await this.storeTransaction(method, api, storedData)
            }
        },
        storeTransaction(method, api, storedData){
            Swal.fire({
            title: 'Apakah anda yakin ingin memproses transaksi?',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Ya!'
            }).then((result) => {
                if (result.value) {
                    // STORE TRANSACTION
                    this.$http({
                        method: method,
                        url: api,
                        data: storedData,
                        headers: { 'Authorization': `Bearer ${this.$cookies.get("token_instance")}` }
                    })
                    .then(response => {
                        const result = response.data;
                        
                        if(result.success) {
                            this.sAlert('success', "Berhasil memproses transaksi!")
                            this.$router.push({ name: 'instanceTransaction' });
                        }else {
                            this.sAlert('error', result.message)
                        }
                        this.loading = false;
                    })
                    .catch(error => {
                        this.loading = false;
                        this.errorHandler(error)
                    });
                }else{
                    this.loading = false
                }
            })
        }
    },
    async mounted() {
        if(!this.$store.state.userData.company.is_transaction == 1){
            this.$router.push({ name: 'instanceTransaction' });
        }

        if(this.companyType == 'HEALTH_CARE'){
            this.transactionForm.objectRetribution = []
        }


        await this.loadInitialData()
        this.transactionForm.date = moment().format('DD/MM/YYYY')
        console.log(this.transactionForm);
    }
}
</script>

<style>

</style>
